// 统一请求路径前缀在libs/axios.js中修改
import {getRequest, postRequest, putRequest, deleteRequest, uploadFileRequest} from '@/libs/axios';


// 添加
export const add = (params) => {
    return postRequest('/base/viptype/add', params)
}

// 修改
export const edit= (params) => {
    return postRequest('/base/viptype/edit', params)
}
// 删除
export const delByIds = (ids) => {
    return postRequest("/base/viptype/delByIds",{
        ids: ids
    })
}

// 列表
export const list = (params) => {
    return postRequest('/base/viptype/list', params)
}

// 获取单个对象
export const getVipType = (id) => {
    return getRequest(`/base/viptype/get/${id}`)
}